import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "vision", label: "Vision" },
  { id: "configurations", label: "Leasing" },
  { id: "location", label: "Location" },
  { id: "register", label: "Register" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[var(--bone)]/92 backdrop-blur-md border-b border-[var(--line)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <button
          onClick={() => scrollTo("top")}
          data-testid="brand-logo"
          className="flex items-baseline gap-2 group"
        >
          <span
            className={`font-serif-display text-xl md:text-2xl tracking-tight transition-colors ${
              scrolled ? "text-[var(--ink)]" : "text-[var(--bone)]"
            }`}
          >
            Elements
          </span>
          <span
            className={`text-xs uppercase tracking-[0.3em] transition-colors ${
              scrolled ? "text-[var(--terracotta)]" : "text-[var(--bone-2)]"
            }`}
          >
            of Meaford
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => scrollTo(l.id)}
              className={`text-xs uppercase tracking-[0.2em] font-semibold transition-colors hover:text-[var(--terracotta)] ${
                scrolled ? "text-[var(--ink)]" : "text-[var(--bone)]"
              }`}
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-register-cta"
            onClick={() => scrollTo("register")}
            className="btn-primary"
            style={{ padding: "0.7rem 1.4rem" }}
          >
            Register Interest
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className={`md:hidden ${scrolled ? "text-[var(--ink)]" : "text-[var(--bone)]"}`}
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[var(--bone)] border-t border-[var(--line)] px-6 py-6 space-y-4"
        >
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}-link`}
              onClick={() => scrollTo(l.id)}
              className="block w-full text-left text-sm uppercase tracking-[0.2em] font-semibold text-[var(--ink)] hover:text-[var(--terracotta)]"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
